const mainProductVariantIds = {
    one: 45387451531485,
    pro: 45387451564253,
    max: 45387451597021,
  }
  const freeItems = {
    one: 45424142975197,
    pro: 45424143007965,
    max: 45424143040733,
  }
  
  function sendUpdates(updates) {
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then(response => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
  
  async function getCart() {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`);
    const data = await response.json();
    return data;
  }
  
  function checkforMainProducts(cart) {
    if(cart.items) {
      const containsMainProducts = cart.items.some(item => Object.values(mainProductVariantIds).includes(item.variant_id));
      return containsMainProducts;
    }
  }
  
  function checkForFreeProducts(cart) {
    if(cart.items) {
      const containsFreeProducts = cart.items.some(item => Object.values(freeItems).includes(item.variant_id));
      return containsFreeProducts;
    } 
  }
  
  /* Refactored */
  function validateItems(itemKey, cart) {
    const freeVariantId = freeItems[itemKey];
    const mainVariantId = mainProductVariantIds[itemKey];
    const containsFreeVariant = cart.items.some(item => item.variant_id === freeVariantId);
    const containsMainVariant = cart.items.some(item => item.variant_id === mainVariantId);
  
    if (!containsFreeVariant && !containsMainVariant) return;
  
    const freeVariantCartItem = cart.items.find(item => item.variant_id === freeVariantId);
    const mainVariantCartItems = cart.items.filter(item => item.variant_id === mainVariantId);
    const mainVariantTotalQuantity = mainVariantCartItems.reduce((acc, item) => acc + item.quantity, 0);
  
    let updates = {};
  
    if (containsFreeVariant) {
      const freeVariantQuantity = freeVariantCartItem.quantity;
      const requiredFreeQuantity = itemKey === "max" ? mainVariantTotalQuantity * 2 : mainVariantTotalQuantity;
  
      if (freeVariantQuantity !== requiredFreeQuantity) {
        updates[freeVariantId] = requiredFreeQuantity;
        sendUpdates(updates);
      }
    }
  
    if (containsMainVariant && !containsFreeVariant) {
      updates[freeVariantId] = itemKey === "max" ? mainVariantTotalQuantity * 2 : mainVariantTotalQuantity;
      sendUpdates(updates);
    }
  
    if (containsFreeVariant && !containsMainVariant) {
      updates[freeVariantId] = 0;
      sendUpdates(updates);
    }
  }
  
  document.addEventListener('booster:cart:update', async (e)=>{  
    const cart = await getCart();
    for(const key of Object.keys(mainProductVariantIds)) {
      validateItems(key, cart);
    }
  })
    